/**
 * Mandatory address fields shared by Registered, Billing and Delivery
 * addresses. Returns the human-readable labels of whichever are empty so the
 * caller can surface a specific message.
 */
export const getMissingAddressFields = (
  addr: any,
  opts?: { requirePincode?: boolean; relaxForNonIndia?: boolean },
): string[] => {
  const requirePincode = opts?.requirePincode ?? true;
  const isIndia =
    !opts?.relaxForNonIndia ||
    String(addr?.country ?? "").trim().toLowerCase() === "india";
  const missing: string[] = [];
  if (!addr?.line1 || !String(addr.line1).trim()) missing.push("Address Line 1");
  if (!addr?.country || !String(addr.country).trim()) missing.push("Country");
  if (!addr?.city || !String(addr.city).trim()) missing.push("City");
  if (isIndia && (!addr?.state || !String(addr.state).trim()))
    missing.push("State");
  if (
    isIndia &&
    requirePincode &&
    (!addr?.pincode || !String(addr.pincode).trim())
  )
    missing.push("Postal Code");
  return missing;
};

export const getCurrentLocation = () => {
  return new Promise<GeolocationPosition>((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve(position);
        },
        (err) => {
          reject(err);
        }
      );
    } else {
      reject("Geolocation is not supported by this browser.");
    }
  });
};
